var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 41,
    viewBox: "0 0 60 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0343 24.0812C29.1686 25.0492 30.84 25.0492 31.9742 24.0812L39.982 17.2504L49.9596 8.7395H10.0532L20.0309 17.2504L28.0386 24.0812H28.0343Z",
    fill: "#00C8B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9915 34.1353V9.34888L32.9038 24.8228C32.5712 25.1042 32.4091 25.488 32.3921 25.8717C30.84 25.3601 29.1685 25.3259 27.6037 25.7779C27.5653 25.424 27.4032 25.0829 27.1005 24.8228L9.01279 9.34888V34.1353H9L51 34.1395H50.9872L50.9915 34.1353Z",
    fill: "#00C8B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0297 19.813L31.5733 22.9342L35.0186 23.4331L32.5241 25.8635L33.1126 29.296L30.0297 27.6757L26.9512 29.296L27.5396 25.8635L25.0452 23.4331L28.4904 22.9342L30.0297 19.813Z",
    fill: "#FFDD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.9804a9a110c8d360e144cde473f8c9b3.svg";
export { ForwardRef as ReactComponent };